import { eTipoPermissao } from '@/enums/ePermissoes';
import Index from '@/views/gestao/sala/Index.vue';
import InclusaoEdicao from '@/views/gestao/sala/InclusaoEdicao.vue';

/*
 * Salas e Ambientes. As duas rotas usam a permissão PRÓPRIA da tela nova
 * (SALASEAMBIENTESNOVO_MENU_300900101, vizinha da 300900100 do legado `SalaNovo.aspx`). Antes elas
 * apontavam para permissões de outras telas (Conteúdo Lecionado / Conteúdos Curriculares),
 * copiadas de um molde — e quem tinha aquelas ganhava esta. Ver docs/salas-ambientes/README.md.
 */
export default [
  {
    description: 'Salas e Ambientes',
    path: '/gestao/sala',
    name: 'sala',
    component: Index,
    meta: {
      permissions: [eTipoPermissao.SALASEAMBIENTESNOVO_MENU_300900101],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Sala / Ambiente',
    path: '/gestao/sala/cadastro/:id?',
    parent: 'sala',
    name: 'sala_create',
    component: InclusaoEdicao,
    meta: {
      permissions: [eTipoPermissao.SALASEAMBIENTESNOVO_MENU_300900101],
    },
    goesToMenu: true,
  },
];
